import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Datepicker from 'vuejs-datepicker'
import { en, es, ptBR } from 'vuejs-datepicker/dist/locale'
import { TheMask } from 'vue-the-mask'

import SinisterMechanicalWorkshop from '@/components/regulation/auto/mechanicalworkshop/sinistermechanicalworkshop.vue'
import Person from '@/components/regulation/auto/person/person.vue'

// import InsurerRepository from '@/shared/http/repositories/configuration/insurer'
// import StageRepository from '@/shared/http/repositories/configuration/stage'
// import RegulationTypeRepository from '@/shared/http/repositories/configuration/regulationtype'
import AutoTypeRepository from '@/shared/http/repositories/configuration/autotype'
import BrandRepository from '@/shared/http/repositories/configuration/brand'
import AutoModelRepository from '@/shared/http/repositories/configuration/automodel'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'
import BusinessTypeRepository from '@/shared/http/repositories/configuration/businesstype'
import ProductRepository from '@/shared/http/repositories/configuration/product'

import SinisterDetailsModel from '@/shared/models/regulation/auto/sinisterdetailsmodel'
import InsuredModel from '@/shared/models/common/insuredmodel'
import ConductorModel from '@/shared/models/common/conductormodel'
import ThirdModel from '@/shared/models/common/thirdmodel'

import SinisterDetailsForms from './sinisterdetails-form'
import SinisterMechanicalWorkshopForms from '@/components/regulation/auto/mechanicalworkshop/form/sinistermechanicalworkshop-form.js'
import InsuredForms from './forms/insured-form'
import ConductorForms from './forms/conductor-form'
import ThirdForms from './forms/third-form'

import InsuranceMixin from '@/store/module/insurance/mixin.js'
import StageMixin from '@/store/module/stage/mixin.js'
import AnalystMixin from '@/store/module/analyst/mixin.js'
import BudgetSystemMixin from '@/store/module/budgetsystem/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationTypeMixin from '@/store/module/regulationtype/mixin'
import ProductMixin from '@/store/module/product/mixin'
import { actionTypes as RegulationActions } from '@/store/module/regulation/actions'
import { globalMutationTypes as RegulationMutations } from '@/store/module/regulation/mutations'
import AccountMixin from '@/store/module/account/mixin'

const STG_PENDING_SCHEDULING = '1e867f06-6d82-4664-0845-08d6050fa3bd'

export default {
  name: 'SinisterDetails',
  props: [ 'clear' ],
  mixins: [
    ActionsForm,
    InsuranceMixin,
    StageMixin,
    AnalystMixin,
    BudgetSystemMixin,
    RegulationMixin,
    RegulationTypeMixin,
    AccountMixin,
    ProductMixin
  ],
  data () {
    return {
      data: SinisterDetailsModel,
      form: SinisterDetailsForms,
      formMarchineWorkshop: SinisterMechanicalWorkshopForms,
      dataInsured: InsuredModel,
      formInsured: InsuredForms,
      dataConductor: ConductorModel,
      formConductor: ConductorForms,
      dataThird: ThirdModel,
      formThird: ThirdForms,
      pollingBusinessType: null,
      pollingBrand: null,
      pollingAutoModel: null,
      pollingProduct: null,
      en: en,
      es: es,
      ptBR: ptBR,
      mechanicalWorkshop: {},
      HasSiniter: false,
      pendingRegulation: null
    }
  },
  components: {
    Datepicker,
    TheMask,
    SinisterMechanicalWorkshop,
    Person
  },
  watch: {
    regulationId: function (value) {
      this.form.regulationAutoID.value = value
    },
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  mounted () {
    this.$refs.PersonInsured.form = this.formInsured
    this.$refs.PersonConductor.form = this.formConductor
    this.$refs.PersonThird.form = this.formThird
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    },
    DetailsPendingRegulation: function () {
      var result = ''
      if (this.pendingRegulation) {
        result = this.pendingRegulation.stage.name + '<br>' + this.pendingRegulation.sinisterCode + '-' + this.pendingRegulation.sinisterVersion
      }
      return result
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.insuranceID.options = result
      }
      return result
    },
    getAllProduct: function () {
      var result = []
      if ((this.products) && (this.products.count) > 0) {
        var data = this.products.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.productID.options = result
      }
      return result
    },
    getAllStage: function () {
      var result = []
      if ((this.stages) && (this.stages.count) > 0) {
        var data = this.stages.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.stageID.options = result
      }
      return result
    },
    getAllAnalyst: function () {
      var result = []
      if ((this.analysts) && (this.analysts.count) > 0) {
        var data = this.analysts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.responsibleID.options = result
      }
      return result
    },
    getAllBudgetSystem: function () {
      var result = []
      if ((this.budgetsystems) && (this.budgetsystems.count) > 0) {
        var data = this.budgetsystems.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.budgetSystemID.options = result
      }
      return result
    },
    getAllRegulationType: function () {
      var result = []
      if ((this.regulationtypes) && (this.regulationtypes.count) > 0) {
        var data = this.regulationtypes.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.regulationTypeID.options = result
      }
      return result
    }
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.$refs.MechanicalWorkshop.mechanicalworkshop = null
      this.$refs.MechanicalWorkshop.onClear()
      this.$refs.PersonInsured.onClear()
      this.$refs.PersonConductor.onClear()
      this.$refs.PersonThird.onClear()
      this.$refs.alert.Close()
    },
    onLoad () {
      this.getAllInsuranceByArea(process.env.AreaAutos)
      this.getAllStageByArea(process.env.AreaAutos)
      this.getAllAnalysts()
      this.getAllBudgetSystems()
      this.getAllRegulationTypeByArea(process.env.AreaAutos)
      // this.onLoadAllRegulationType()
      this.onLoadAllAutoType()
    },
    onCreate () {
      loading.push()
      RegulationAutoRepository.Create(this.data)
        .then((response) => {
          this.onResult(response, true, true)
          // TODO REMOVER APÓS IMPLEMENTAÇÃO CORRETA
          if (response) {
            this.form.id.value = response.data.data.id
            this.$store.commit(RegulationMutations.SET_REGULATION, response.data.data)
            // SDS-61 - Força mostrar que ja foi agendado automaticamente
            if (response.data.data.stage) {
              this.form.stageID.value = response.data.data.stageID
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegulationAutoRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      this.onClear()
      if (obj) {
        var self = this
        // DADOS SINISTROS e DADOS PARECER E RECLAMADO
        Tools.SetValueInForm(self.form, self.data, obj)

        this.HasSiniter = false

        // TIPO DE NEGÓCIO
        this.onChangeInsurance()
        this.pollingBusinessType = setInterval(() => {
          this.setBusinessType(obj.businessTypeID)

          // PRODUTO
          this.onChangeBusinessType()
          // this.pollingProduct = setInterval(() => {
          //   this.setProduct(obj.productID)
          // }, 500)
        }, 500)

        // DADOS OFICINA
        if (self.$refs.MechanicalWorkshop) {
          self.$refs.MechanicalWorkshop.onEditById(obj.mechanicalWorkshopID)
        }

        // DADOS VEICULO
        self.setAutoType(obj.autoModel.brand.autoTypeID)
          .then(func => setTimeout(() => {
            self.changeAutoType(obj.autoModel.brand.autoTypeID, func)
          }, 100))
          .catch(function (err) {
            console.log(err)
          })

        // DADOS DA MARCA
        this.pollingBrand = setInterval(() => {
          this.setBrand(obj.autoModel.brandID)
          this.changeBrand(obj.autoModel.brandID)
        }, 500)
        // DADOS DO MODELO
        this.pollingAutoModel = setInterval(() => {
          this.setAuto(obj.autoModel.id)
        }, 500)

        // DADOS DO SEGURADO
        if (self.$refs.PersonInsured) {
          self.$refs.PersonInsured.onEditById(obj.insuredID)
        }

        // DADOS DO CONDUTOR
        if (self.$refs.PersonConductor) {
          self.$refs.PersonConductor.onEditById(obj.conductorID)
        }

        // DADOS DO TERCEIRO
        if (self.$refs.PersonThird) {
          self.$refs.PersonThird.onEditById(obj.thirdID)
        }
      }
    },
    onCheckSinister () {
      var sinister = this.form.sinisterCode.value
      var sinisterVersion = this.form.sinisterVersion.value
      this.form.stageID.value = STG_PENDING_SCHEDULING
      if (!this.HasSiniter) {
        loading.push()
        RegulationAutoRepository.GetBySinister(sinister, sinisterVersion)
          .then((response) => {
            if (response) {
              var obj = response.data.data
              if (obj && obj.id) {
                this.HasSiniter = true
                toast.warning(this.$lang.Sinister.Details.AlertSinisterHasExist)
                this.onEdit(obj)
                this[RegulationActions.GET_BY_ID](obj.id)
                  .then((response) => {
                  })
              } else {
                // Obtendo o tipo da vistoria (olhando para vistorias anteriores e carregando os dados)
                if (parseInt(sinisterVersion) > 0) {
                  RegulationAutoRepository.GetTypeBySinisterVersion(parseInt(sinister), sinisterVersion)
                    .then((response) => {
                      var obj = response.data.data
                      if (obj) {
                        // Há um vistoria não concluida
                        this.$refs.MechanicalWorkshop.onEditById(null)
                        if (obj.stage) {
                          this.pendingRegulation = obj
                          this.$refs['modal-pending-regulation'].show()
                        } else {
                          this.onLoadPreAdding(obj)
                        }
                      }
                    })
                    .catch((err) => {
                      this.onException(err)
                    })
                }
              }
            }
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.HasSiniter = false
      }
    },
    onUnlockStage () {
      this.$refs['modal-unlock-regulation'].show()
    },
    onUnlockStageModalClose () {
      this.$refs['modal-unlock-regulation'].hide()
    },
    onUnlockStageModalYes () {
      this.$refs['modal-unlock-regulation'].hide()
      loading.push()
      var id = this.form.id.value
      if (id) {
        RegulationAutoRepository.ChangeStageRegulationToDigitation(id)
          .then((response) => {
            this.onEdit(response.data.data)
            this[RegulationActions.GET_BY_ID](response.data.data.id)
              .then((response) => {
              })
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch((err) => {
            this.onException(err)
            loading.close()
            toast.error(this.$lang.Common.Alerts.Error)
          })
      } else {
        loading.close()
        toast.error(this.$lang.Common.Alerts.Error)
      }
    },
    onLoadAllAutoType () {
      loading.push()
      AutoTypeRepository.GetAll()
        .then((response) => {
          this.form.autoTypeID.options = this.onResultDropdown(response, true)
        })
        .catch((err) => {
          this.onException(err)
        })
      this.form.autoTypeID.value = null
    },
    onLoadAllBrand (typeID) {
      this.form.brandID.options = []
      this.form.autoModelID.options = []
      if (typeID) {
        loading.push()
        BrandRepository.GetAllByAutoTypeID(typeID)
          .then((response) => {
            this.form.brandID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.brandID.value = null
      }
    },
    onLoadAllAutoModel (brandID) {
      this.form.autoModelID.options = []
      if (brandID) {
        loading.push()
        AutoModelRepository.GetAllByBrandID(brandID)
          .then((response) => {
            this.form.autoModelID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
        this.form.autoModelID.value = null
      }
    },
    onLoadAllBusinessType (insuranceID) {
      this.form.businessTypeID.options = []
      this.form.productID.options = []
      if (insuranceID) {
        loading.push()
        BusinessTypeRepository.GetAllByInsuranceID(insuranceID)
          .then((response) => {
            this.form.businessTypeID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
      // this.form.businessTypeID.value = null
    },
    onLoadAllProductByBusinessType (form) {
      this.form.productID.options = []
      if (form.insuranceID && form.businessTypeID) {
        loading.push()
        ProductRepository.GetByInsuranceAndBusinessType(form.insuranceID.value, form.businessTypeID.value)
          .then((response) => {
            this.form.productID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
      // this.form.productID.value = null
    },
    onChangeInsurance () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBusinessType(self.form.insuranceID.value)
      }, 500)
    },
    onChangeBusinessType () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllProductByBusinessType(self.form)
      }, 500)
    },
    onChangeAutoType () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBrand(self.form.autoTypeID.value)
      }, 500)
    },
    onChangeBrand () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllAutoModel(self.form.brandID.value)
      }, 500)
    },
    onEditMechanicalWorkshop (obj) {
      this.form.mechanicalWorkshopID.value = null
      this.mechanicalWorkshop = null
      if (obj) {
        this.form.mechanicalWorkshopID.value = obj.id
        this.mechanicalWorkshop = obj
        this.$emit('Edit', obj)
      }
    },
    onEditInsured (obj) {
      this.form.insuredID.value = null
      if (obj) {
        this.form.insuredID.value = obj.id
      }
    },
    onEditConductor (obj) {
      this.form.conductorID.value = null
      if (obj) {
        this.form.conductorID.value = obj.id
      }
    },
    onEditThird (obj) {
      this.form.thirdID.value = null
      if (obj) {
        this.form.thirdID.value = obj.id
      }
    },
    setAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoTypeID.value = autoTypeID
          resolve()
        }, 300)
      })
    },
    changeAutoType (autoTypeID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.brandID.options = []
          self.form.autoModelID.options = []
          loading.push()
          BrandRepository.GetAllByAutoTypeID(autoTypeID)
            .then((response) => {
              self.form.brandID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 400)
      })
    },
    setBrand (brandID, resolve) {
      var self = this
      if ((brandID) && (brandID !== '00000000-0000-0000-0000-000000000000')) {
        if (this.form.brandID.options.length > 0) {
          clearInterval(this.pollingBrand)
          return new Promise(function (resolve, reject) {
            setTimeout(function (e) {
              self.form.brandID.value = brandID
              // self.changeBrand(brandID)
              resolve()
            }, 200)
          })
        }
      } else {
        clearInterval(this.pollingBrand)
        self.form.brandID.value = null
      }
    },
    changeBrand (brandID, resolve) {
      var self = this
      return new Promise(function (resolve, reject) {
        setTimeout(function (e) {
          self.form.autoModelID.options = []
          loading.push()
          AutoModelRepository.GetAllByBrandID(brandID)
            .then((response) => {
              self.form.autoModelID.options = self.onResultDropdown(response, true)
            })
            .catch((err) => {
              self.onException(err)
            })
          resolve()
        }, 800)
      })
    },
    setAuto (autoModelID, resolve) {
      var self = this
      if ((autoModelID) && (autoModelID !== '00000000-0000-0000-0000-000000000000')) {
        if (this.form.autoModelID.options.length > 0) {
          clearInterval(this.pollingAutoModel)
          return new Promise(function (resolve, reject) {
            setTimeout(function (e) {
              self.form.autoModelID.value = autoModelID
              resolve()
            }, 200)
          })
        }
      } else {
        clearInterval(this.pollingAutoModel)
        self.form.autoModelID.value = null
      }
    },
    setBusinessType (businessTypeID, resolve) {
      var self = this
      if ((businessTypeID) && (businessTypeID !== '00000000-0000-0000-0000-000000000000')) {
        if (this.form.businessTypeID.options.length > 0) {
          clearInterval(this.pollingBusinessType)
          return new Promise(function (resolve, reject) {
            setTimeout(function (e) {
              self.form.businessTypeID.value = businessTypeID
              resolve()
            }, 200)
          })
        }
      } else {
        clearInterval(this.pollingBusinessType)
        self.form.businessTypeID.value = null
      }
    },
    setProduct (productID, resolve) {
      // var self = this
      // if ((productID) && (productID !== '00000000-0000-0000-0000-000000000000')) {
      //   if (this.form.productID.options.length > 0) {
      //     console.log('product list has more than one item')
      //     clearInterval(this.pollingProduct)
      //     return new Promise(function (resolve, reject) {
      //       setTimeout(function (e) {
      //         self.form.productID.value = productID
      //         resolve()
      //       }, 200)
      //     })
      //   }
      // } else {
      //   console.log('product list dont have itens')
      //   clearInterval(this.pollingProduct)
      //   self.form.productID.value = null
      // }
    },
    onLoadPreAdding (obj) {
      this.form.insuranceID.value = obj.insuranceID
      this.form.regulationTypeID.value = obj.regulationTypeID
      this.form.responsibleID.value = obj.responsibleID
      this.form.budgetSystemID.value = obj.budgetSystemID

      // TIPO DE NEGÓCIO
      this.onChangeInsurance()
      this.pollingBusinessType = setInterval(() => {
        this.setBusinessType(obj.businessTypeID)

        // PRODUTO
        this.onChangeBusinessType()
        // this.pollingProduct = setInterval(() => {
        //   this.setProduct(obj.productID)
        // }, 500)
      }, 500)

      this.$refs.MechanicalWorkshop.onEditById(obj.mechanicalWorkshopID)

      this.form.year.value = obj.year
      this.form.color.value = obj.color
      this.form.plate.value = obj.plate
      this.form.chassis.value = obj.chassis
      // TIPO DE VEÍCULO
      if (obj.autoModel) {
        this.setAutoType(obj.autoModel.brand.autoTypeID)
          .then(func => setTimeout(() => {
            this.changeAutoType(obj.autoModel.brand.autoTypeID, func)
          }, 100))
          .catch(function (err) {
            console.log(err)
          })
        // DADOS DA MARCA
        this.pollingBrand = setInterval(() => {
          this.setBrand(obj.autoModel.brandID)
          this.changeBrand(obj.autoModel.brandID)
        }, 500)
        // DADOS DO MODELO
        this.pollingAutoModel = setInterval(() => {
          this.setAuto(obj.autoModel.id)
        }, 500)
      }
      // DADOS DO SEGURADO
      if (this.$refs.PersonInsured) {
        this.$refs.PersonInsured.onEditById(obj.insuredID)
      }
      // DADOS DO CONDUTOR
      if (this.$refs.PersonConductor) {
        this.$refs.PersonConductor.onEditById(obj.conductorID)
      }
      // DADOS DO TERCEIRO
      if (this.$refs.PersonThird) {
        this.$refs.PersonThird.onEditById(obj.thirdID)
      }
    },
    onCloseModal () {
      this.onLoadPreAdding(this.pendingRegulation)
      this.$refs['modal-pending-regulation'].hide()
    },
    onCloseModalClear () {
      this.onClear()
      this.$refs['modal-pending-regulation'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/details/sinisterdetails.js